import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Image from '../../../objects/image/SecondaryImage';
import LibraryImage from '../../../objects/image/SecondaryLibraryImage';
import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as assetConstants from '../../../../constants/assetConstants';
import * as appConstants from '../../../../constants/appConstants';
import * as keyboardConstants from '../../../../constants/keyboardConstants';

class GridChoiceOption extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            option: this.props.option,
            locale: appHelper.getLocalData(this.props.option),
            responseData: this.props.responseData,
            optionAsset: {
                src: ""
            },
            assetData: {},
            focusedOption: this.props.focusedOption,
            focusedClass:"not-focused",
        };
        this.getAssets = this.getAssets.bind(this);
        this.getAssetType = this.getAssetType.bind(this);
        this.removeOption = this.removeOption.bind(this);
        this.onOptionHidden = this.onOptionHidden.bind(this);
        this.getDisabledState = this.getDisabledState.bind(this);
        this.getOptionClass = this.getOptionClass.bind(this);
        this.onOptionRevealed = this.onOptionRevealed.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.renderOption = this.renderOption.bind(this);
        this.getCheckedState = this.getCheckedState.bind(this);
        this.getIsChecked = this.getIsChecked.bind(this);
        this.getIsDisabled = this.getIsDisabled.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.setBlur = this.setBlur.bind(this);
        this.getScreenReaderOptionClass = this.getScreenReaderOptionClass.bind(this);
    }

    componentDidMount() {
        this.getAssets();
       // this.showOption(1, 0);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.responseData !== nextProps.responseData) {
            this.setState({responseData: nextProps.responseData});
        }

        if (this.state.focusedOption !== nextProps.focusedOption) {
            this.setState({focusedOption: Object.assign({}, nextProps.focusedOption)});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option)
            });
        }
    }

    componentDidUpdate() {
    }

    getAssets(){
        let screenAsset = {};
        let assetData = {};

        if(appHelper.isDefined(this.state.option.image)){
            screenAsset = this.getAssetType(this.state.option.image);
            assetData = Object.assign({}, this.state.option.image);
        }

        this.setState({
            screenAsset: Object.assign({},screenAsset),
            assetData: Object.assign({},assetData)
        });
    }

    getAssetType(asset){
        /*
         screenCharacter = appHelper.getCharacterAsset(this.state.screen.assets.left);
            //console.log(screenCharacter);
            characterAsset = appHelper.getCharacterPose(screenCharacter, this.state.screen.assets.left);
        * */
        let returnAsset = {};
        if(asset.constant === assetConstants.ASSET_TYPE_ICON){
            returnAsset = appHelper.getIconAsset(asset);
        }else if(asset.constant === assetConstants.ASSET_TYPE_IMAGE){
            returnAsset = appHelper.getImageAsset(asset);
        }else if(asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE){
            returnAsset = appHelper.getLibraryImageAsset(asset);
        }else if(asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER){
            let characterAsset = appHelper.getCharacterAsset(asset);
            returnAsset = appHelper.getCharacterPose(characterAsset, asset);
        }

        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if(appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)){
            returnAsset = Object.assign({},returnAsset,{
                type: asset.constant
            });
        }
        return returnAsset;
    }
    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }
    getOptionClass() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        if (this.props.questionChecked) {
            if(this.props.showOutcome  || this.state.option.result === objectConstants.SCORING_TYPE_REFLECTIVE) {
                if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
                    if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id)) {
                        if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED) {
                            return `active ${this.state.option.result}`;
                        } else if(responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && this.props.showFeedback){
                            return `selected ${this.state.option.result}`;
                        }else if(responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && !this.props.showFeedback){
                            return `selected inactive-answered ${this.state.option.result}`;
                        }
                    } else {
                        for (let i = 0; i < this.state.responseData.responses.length; i++) {
                            let response = this.state.responseData.responses[i];
                            if (response.selectedOption.option_id === this.state.option.option_id) {
                                return `show-answer ${this.state.option.result}`;
                            }
                        }
                    }
                } else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
                    if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id) && this.props.showFeedback) {
                        return `selected answered ${this.state.option.result}`;
                    }else if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id) && !this.props.showFeedback) {
                        return `selected inactive-answered ${this.state.option.result}`;
                    } else {
                        return `review ${this.state.option.result}`;
                    }

                }
            }else{
                return `selected assessment`;
            }
        }

        if(appHelper.isDefined(responseData.latestResponse) && responseData.latestResponse.option_id === this.state.option.option_id){
            return "checked";
        }

        return "";
    }

	getScreenReaderOptionClass() {
		let responseData = this.state.responseData;
		let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
		if (this.props.questionChecked) {

			if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
				if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id)) {
					if (responseData.displayState !== objectConstants.OBJECT_DISPLAY_STATE_ANSWERED) {
						return "";
					} else if(responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && this.props.showFeedback){
						return appHelper.getOptionResultString(this.state.option.result,false);
					}else if(responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_ANSWERED && !this.props.showFeedback){
						return appHelper.getOptionResultString(this.state.option.result,false);
					}
				} else {
					for (let i = 0; i < this.state.responseData.responses.length; i++) {
						let response = this.state.responseData.responses[i];
						if (response.selectedOption.option_id === this.state.option.option_id) {
							return appHelper.getOptionResultString(this.state.option.result,true);
						}
					}
				}
			} else if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_REVIEW) {
				if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id) && this.props.showFeedback) {
					return appHelper.getOptionResultString(this.state.option.result,false);
				}else if ((responseData.currentAttempt === responseData.responses.length) && (latestResponse.selectedOption.option_id === this.state.option.option_id) && !this.props.showFeedback) {
					return appHelper.getOptionResultString(this.state.option.result,false);
				} else {
					return appHelper.getOptionResultString(this.state.option.result,false);
				}

			}
		}



		return "";
	}

    renderOption(){
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);
        if (this.props.questionChecked && this.props.currentlyChecked) {
            if(latestResponse.selectedOption.option_id === this.state.option.option_id){
                return true;
            }else{
                return false;
            }
        }else{
            return true;
        }
    }


    getDisabledState() {
        let responseData = this.state.responseData;
        //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
        if (responseData.currentAttempt === responseData.responses.length && this.props.questionChecked) {
            return `disabled`;
        } else {
            for (let i = 0; i < this.state.responseData.responses.length; i++) {
                let response = this.state.responseData.responses[i];
                if (response.selectedOption.option_id === this.state.option.option_id && this.props.questionChecked) {
                    return `disabled`;
                }
            }
            return null;
        }
    }


    getCheckedState(){
        let responseData = this.state.responseData;
        let latestResponse = responseData.latestResponse;
        //console.log(`getCheckedState`,latestResponse);
        if (appHelper.isDefined(latestResponse.option_id) && latestResponse.option_id === this.state.option.option_id) {
            //console.log(`getCheckedState`, latestResponse);
            return `checked`;
        }
    }

    onOptionRevealed(){
        this.props.onOptionRevealed(this.props.option);
    }




    onOptionHidden() {
        let responseData = this.state.responseData;
        let latestResponse = appHelper.getLastItemOfArray(responseData.responses);

        //if selected option is first in the list
        if (latestResponse.index === 0) {
            this.removeOption();
        } else {
            this.scaleOptionHeight();
        }
    }

    removeOption() {
        //this.setState({render: false});
    }

    getIsChecked() {
        let responseData = this.state.responseData;
        let latestResponse = responseData.latestResponse;
        //console.log(`getCheckedState`,latestResponse);
        if(appHelper.isDefined(latestResponse.option_id) && latestResponse.option_id === this.state.option.option_id) {
            //console.log(`getCheckedState`, latestResponse);
            return true;
        }else{
            return false;
        }
    }

    getIsDisabled() {
        let responseData = this.state.responseData;
        //if (responseData.displayState === objectConstants.OBJECT_DISPLAY_STATE_INITIAL) {
        if (responseData.currentAttempt === responseData.responses.length || this.state.isAnimating) {
            return true;
        } else {
            for (let i = 0; i < this.state.responseData.responses.length; i++) {
                let response = this.state.responseData.responses[i];
                if (response.selectedOption.option_id === this.state.option.option_id) {
                    return true;
                }
            }
            return false;
        }
    }

    setFocus(){
        this.setState({focusedClass:"focused"});
    }
    setBlur(){
        this.setState({focusedClass:"not-focused"});
    }

    render() {

        return (
            this.renderOption()
                ?
                    <div className={`multiple-choice-option ${this.getOptionClass()} ${this.state.focusedClass}`}
                        ref={this.state.option.option_id}
                         id={`option_${this.state.option.option_id}`}
                         onClick={this.getClickFunction}
                         onKeyDown={this.props.optionCallbacks.setKeyboardAccessibility}
                         onFocus={this.setFocus}
                         onBlur={this.setBlur}
                         role="radio"
                         tabIndex={this.state.focusedOption.option_id === this.state.option.option_id ? 0 : -1}
                         aria-checked={this.getIsChecked()}
                         aria-disabled={this.getIsDisabled()}>

                        <input id={`${this.props.asset_id}_${this.state.option.option_id}`} type="radio"
                               disabled={this.getDisabledState()}
                               name={this.props.asset_id}
                               checked={this.getCheckedState()}
                               value={this.state.option.option_id} onChange={this.props.onOptionClick}/>
                        <label htmlFor={`${this.props.asset_id}_${this.state.option.option_id}`}>

                            <div className="label-text" dangerouslySetInnerHTML={{__html: this.state.locale.option}}/>
                            {
                                appHelper.isDefined(this.state.assetData.constant)
                                    ?
                                    <div className="image-container">

                                        {this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE || this.state.assetData.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE
                                            ?
                                            this.state.assetData.constant === assetConstants.ASSET_TYPE_IMAGE
                                                ?
                                                <Image screenObject={this.state.assetData}/>
                                                :
												<LibraryImage screenObject={this.state.assetData}/>
                                            :
                                            <div><img src={this.getImagePath(this.state.screenAsset.src)} alt=""/></div>
                                        }
                                    </div>
                                    :
                                    null
                            }
							<span className="hidden-el">{this.getScreenReaderOptionClass()}</span>
                        </label>
                    </div>
                :
                    null


        );

    }
}

GridChoiceOption.propTypes = {
    option: PropTypes.object.isRequired,
    asset_id: PropTypes.number.isRequired,
    questionChecked: PropTypes.bool.isRequired,
    currentlyChecked: PropTypes.bool.isRequired,
    responseData: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    onOptionClick: PropTypes.func,
    onAttemptComplete: PropTypes.func,
    onReviewObject: PropTypes.func,
    onOptionRevealed: PropTypes.func,
    showFeedback: PropTypes.bool,
    focusedOption: PropTypes.object,
    optionCallbacks:PropTypes.object,
    showOutcome: PropTypes.bool,
    contentData: PropTypes.object,
    trackingData: PropTypes.object,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

GridChoiceOption.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GridChoiceOption);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/gridChoice/GridChoiceOption.js
 **/